<template>
  <div class="animated fadeIn frm-mutasi">
        <b-card>
            <div slot="header">
                Fixed Asset Mutation Form
                <div class="card-header-actions">
                <button  v-if="saveEnabled" class="btn btn-primary mr-1" @click="save()"><i class="fa fa-save"></i> Save</button>
                  <button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
                </div>
            </div>
              <b-row>
                <b-col lg="7">
                    <b-row>
                        <b-col lg="6">
                            <b-input-group>
                                <b-input-group-prepend><label>Mutation Number</label></b-input-group-prepend>
                                <b-form-input v-model="model.nomor" readonly></b-form-input>
                            </b-input-group>
                        </b-col>
                        <b-col lg="6">                            
                            <b-input-group>
                                <b-input-group-prepend><label class="text-right">Mutation Date</label></b-input-group-prepend>
                                <b-form-input v-model="model.tanggal" type="date"  :state="!$v.model.tanggal.$error"></b-form-input>                                        
                            </b-input-group>
                        </b-col>
                    </b-row>   
                    <b-input-group >
                      <b-input-group-prepend><label>Mutation To</label></b-input-group-prepend>
                      <b-form-radio v-model="model.aspublic" :value="1" class="mt-2">Department/Public Assets</b-form-radio>
                            <b-form-input readonly v-model="model.asuser" :state="!$v.model.asuser.$error"></b-form-input>
                            <b-input-group-append>
                            <b-btn text="Button" @click="lkuDeptShow=true" :disabled="(model.aspublic!=1)" >
                                <i class="fa fa-search"></i>
                            </b-btn>
                            </b-input-group-append>
                    </b-input-group>
                    <b-input-group >
                      <b-input-group-prepend><label>&nbsp;</label></b-input-group-prepend>
                              <b-form-radio v-model="model.aspublic" :value="0" class="mt-2" style="width: 183px !important;">Dedicated Employee</b-form-radio>
                            <b-form-input readonly v-model="model.crewinfo" :state="!$v.model.crewkey.$error"></b-form-input>
                            <b-input-group-append>
                            <b-btn text="Button" @click="lkuCrewShow=true" :disabled="(model.aspublic!=0)" >
                                <i class="fa fa-search"></i>
                            </b-btn>
                            </b-input-group-append>
                    </b-input-group>
                    <b-input-group >
                      <b-input-group-prepend><label>&nbsp;</label></b-input-group-prepend>
                              <b-form-radio v-model="model.aspublic" :value="-1" class="mt-2" style="width: 183px !important;">Inventory Store(No User)</b-form-radio>
                          <b-form-select v-model="model.idStore" :plain="true" :options="warehouse" :state="!$v.model.idStore.$error" :disabled="(model.aspublic!=-1)" ></b-form-select>
                    </b-input-group>

                </b-col>
                <b-col lg="5" >
                      <b-input-group>
                          <b-input-group-prepend><label style="width:150px !important;">Peminjaman Jk.Pendek </label></b-input-group-prepend>
                          <div style="flex: 1 1 auto;width: 1%;" >
                              <b-form-radio-group  v-model="model.targetkembali" name="radioTargetKembali" class="ml-1 mt-1" :state="!$v.model.targetkembali.$error" @change="updateUser">
                                  <b-form-radio :value="0">Tidak</b-form-radio>
                                  <b-form-radio :value="1">Ya (harus dikembalikan segera)</b-form-radio>
                              </b-form-radio-group>
                          </div>
                      </b-input-group>
                      <b-input-group>
                          <b-input-group-prepend><label style="width:150px !important;">Batas Pengembalian</label></b-input-group-prepend>
                          <b-form-input v-model="model.tglkembali" type="date"  :state="!$v.model.tglkembali.$error" :disabled="(model.targetkembali==0)"></b-form-input>                                        
                      </b-input-group>
                      <br>
                  <b-input-group >
                      <b-input-group-prepend><label style="width:150px !important;">New Asset Location</label></b-input-group-prepend>
                      <b-form-input v-model="model.aslocat" placeholder="location remark"></b-form-input>
                            <b-form-input readonly v-model="model.lokasiinfo" style="width:30% !important;"></b-form-input>
                            <b-input-group-append>
                            <b-btn text="Button" @click="lkuAssetlocatShow=true">
                                <i class="fa fa-search"></i>
                            </b-btn>
                            </b-input-group-append>
                  </b-input-group>

                </b-col>
            </b-row>   
                    <b-input-group >
                        <b-input-group-prepend><label>Description</label></b-input-group-prepend>
                        <b-form-input v-model="model.uraian" :state="!$v.model.uraian.$error" placeholder="Note/Remark"></b-form-input>
                    </b-input-group>

              <b-card no-body class="mb-1">
                <b-table
                    class="mb-0"
                    ref="tblIssuedLines"
                    outlined
                    striped hover small
                    style="font-size:smaller;"
                    :items="issuedLines.items"
                    :fields="tblFields"
                    :current-page="issuedLines.page"
                    :per-page="issuedLines.limit"
                    show-empty
                    >
                        <template v-slot:cell(index)="data">
                            {{data.index + 1}}
                        </template>
                        <template v-slot:cell(action)="data">
                            <div class="text-center">
                            <a href="javascript:void(0)" class="text-danger" @click="delIssuedLines(data.index)">
                                <i class="fa fa-trash"></i>
                            </a>
                            </div>
                        </template>
                        <template v-slot:row-details="row">
                    <b-card class="row-details-form">
                      <b-row  align-h="center">
                        <b-col lg="6" xl="6">
                            <b-input-group>
                                  <b-input-group-prepend><label>Fixed Asset</label></b-input-group-prepend>
                                  <b-form-input v-model="issuedLinesObj.asetid" :state="!$v.issuedLinesObj.asetkey.$error" readonly class="mr-1" ></b-form-input>  
                                  <b-form-input v-model="issuedLinesObj.asdesc" :state="!$v.issuedLinesObj.asetkey.$error" readonly style="width:45% !important;"></b-form-input>                                        
                                  <b-input-group-append>
                                  <b-btn text="Button" @click="lkuFixedAssetShow=true" >
                                      <i class="fa fa-search"></i>
                                  </b-btn>
                                  </b-input-group-append>
                              </b-input-group>
                                <b-row>
                                  <b-col lg="6" >
                                    <b-input-group >
                                        <b-input-group-prepend><label>Group/Category</label></b-input-group-prepend>
                                        <b-form-input v-model="issuedLinesObj.catgname" readonly></b-form-input>                                        
                                    </b-input-group>
                                  </b-col>
                                  <b-col lg="6">                            
                                    <b-input-group >
                                        <b-input-group-prepend><label>Model/Type</label></b-input-group-prepend>
                                        <b-form-input v-model="issuedLinesObj.asmodel" readonly></b-form-input>
                                    </b-input-group>
                                  </b-col>
                                </b-row>
                                <b-row>
                                  <b-col lg="6" >
                                    <b-input-group >
                                        <b-input-group-prepend><label>Serial Number</label></b-input-group-prepend>
                                        <b-form-input disabled v-model="issuedLinesObj.asserial" readonly></b-form-input>                                        
                                    </b-input-group>
                                  </b-col>
                                  <b-col lg="6" >
                                    <b-input-group >
                                        <b-input-group-prepend><label>Usage Date</label></b-input-group-prepend>
                                        <b-form-input disabled v-model="issuedLinesObj.asdatuse" type="date"  readonly></b-form-input>                                        
                                    </b-input-group>
                                  </b-col>
                                </b-row>

                        </b-col>
                        <b-col lg="6" xl="5">
                            <b-input-group>
                                <b-input-group-prepend><label>Mstr. Material Reff</label></b-input-group-prepend>
                                <b-form-input readonly v-model="issuedLinesObj.iteminfo" @keyup.13.native="lkuItemShow=true" :state="!$v.issuedLinesObj.itemno.$error"></b-form-input>
                                <b-input-group-append>
                                <b-btn text="Button" @click="lkuItemShow=true" >
                                    <i class="fa fa-search"></i>
                                </b-btn>
                                </b-input-group-append>
                            </b-input-group>
                            <b-form-row>
                              <b-col lg="6">                            
                                <b-input-group>
                                    <b-input-group-prepend><label>Quantity</label></b-input-group-prepend>
                                    <b-form-input v-model="issuedLinesObj.quantity" type="number" readonly></b-form-input>
                                    <b-input-group-append><span>{{ issuedLinesObj.invunitom }}</span></b-input-group-append>
                                </b-input-group>
                              </b-col>
                            </b-form-row >     
                        </b-col>
                      </b-row>
                      <b-row class="justify-content-center mt-1">
                        <div style="width:400px;">
                            <b-input-group >
                                <b-input-group-append>
                                    <b-button class="btn btn-success mr-1" @click="saveIssuedLines()">Update</b-button>
                                </b-input-group-append>
                                <b-input-group-append>
                                    <b-button class="btn btn-warning ml-1" @click="row.toggleDetails">Cancel</b-button>
                                </b-input-group-append>
                            </b-input-group>
                        </div>
                      </b-row>
                    </b-card>
                    </template>                        

                    <template v-slot:cell(empty)="scope">
                        <h4>{{ scope.emptyText }}</h4>
                    </template>
                    <template v-slot:cell(emptyfiltered)="scope">
                        <h4>{{ scope.emptyFilteredText }}</h4>
                    </template>                        
                </b-table>
                <b-form-row>
                    <b-col cols="6">
                        <b-row>
                        <b-button size="sm" class="ml-3" @click.stop="lkuFixedAssetShow=true" >Add Asset</b-button>                          
                        <div class="ml-2">
                            Showing
                            {{(issuedLines.page - 1) * issuedLines.limit + 1}}
                            to
                            {{issuedLines.page * issuedLines.limit}}
                            <strong>
                            of
                            {{issuedLines.total}}
                            entries </strong>
                        </div>    
                        </b-row>                    
                    </b-col>
                    <b-col cols="6">
                    <b-pagination
                        align="right"
                        :total-rows="issuedLines.total"
                        :per-page="issuedLines.limit"
                        v-model="issuedLines.page"
                    ></b-pagination>
                    </b-col>
                </b-form-row>
              </b-card>    
            <b-row class="justify-content-center mb-2">
                <button  v-if="saveEnabled" class="btn btn-primary mr-1" @click="save()"><i class="fa fa-save"></i> Save</button>
                <button class="btn btn-primary" @click="close()" > <i class="fa fa-close"></i> Close</button>
            </b-row>
    </b-card>
        <b-modal v-model="lkuFixedAssetShow" size="lg" :hide-footer="true" title="List of Fixed Asset" :centered="true">
            <lku-fixedasset @click="onSelectLkuFixedAsset" :formdata="lkuFixedAssetData"></lku-fixedasset>
        </b-modal>        
        <b-modal v-model="lkuCrewShow" size="lg" :hide-footer="true" title="List of Employee" :centered="true">
            <lku-crew @click="onSelectLkuCrew" :formdata="lkuCrewData"></lku-crew>
        </b-modal>        
        <b-modal v-model="lkuAssetlocatShow" size="lg" :hide-footer="true" title="List of Location" :centered="true">
            <lku-assetlocat @click="onSelectLkuAssetlocat"></lku-assetlocat>
        </b-modal>   
        <b-modal v-model="lkuDeptShow" size="lg" :hide-footer="true" title="List of Department" :centered="true">
            <lku-department @click="onSelectLkuDept"></lku-department>
        </b-modal>        
        <b-modal v-model="lkuItemShow" size="lg" :hide-footer="true" title="List of Master Item" :centered="true">
            <lku-item @click="onSelectLkuItem"   :formdata="itemList"></lku-item>
        </b-modal>        

  </div>
</template>

<style lang="scss">
   .frm-mutasi{
    .input-group {
        padding-bottom:2px;
        .input-group-prepend {
            label {
                padding-top: 5px;
                padding-right: 5px;
                width: 100px;
            }
        }
    }

   }
</style>


<script>
import toastr from "mini-toastr";
import moment from 'moment';
import crud from "../../apis/crud";
import fa_mutation from "../../apis/fa_mutasi";
import lkuFixedasset from "../lookup/lkuFassetLazzy";
import lkuCrew from "../lookup/lkuCrewlazzy";
import lkuDepartment from "../lookup/lkuDepartment";
import lkuAssetlocat from "../lookup/lkuAssetlocat";
import lkuItem from "../lookup/lkuItemLazzy";
import { validationMixin } from "vuelidate";
import { required, minValue,numeric } from "vuelidate/lib/validators";
toastr.init();

export default {
  components: { lkuFixedasset, lkuCrew, lkuDepartment, lkuAssetlocat, lkuItem},
  mixins: [validationMixin],
  validations: {
        model: {
          tanggal: { required },
          uraian: { required },
          aspublic: { required},
          asuser: {required : (function() {
                if ((this.model.aspublic || 0) != 0) {
                    return true;
                } else if (!(this.model.asuser)){
                    return false;
                } else return true;
            })},
          crewkey: {required : (function() {
                if ((this.model.aspublic || 0) != 1) {
                    return true;
                } else if (!(this.model.crewkey)){
                    return false;
                } else return true;
            })},
          idStore: {required : (function() {
                if ((this.model.aspublic || 0) != -1) {
                    return true;
                } else if (!(this.model.idStore)){
                    return false;
                } else return true;
            })},
          targetkembali: { required },
          tglkembali: {required : (function() {
                if ((this.model.targetkembali || 0) == 0) {
                    return true;
                } else if (!(this.model.tglkembali)){
                    return false;
                } else return true;
            })},
        },
        issuedLinesObj: {
            asetkey: { required },
            itemno: { required }
        }
  },
  data() {
    return {
      saveEnabled: true,
      lkuItemShow:false,
      itemList:{},
      lkuFixedAssetData: {},
      lkuFixedAssetShow: false,
      lkuCrewData:{},
      lkuCrewShow:false,
      lkuDeptShow: false,
      lkuAssetlocatShow:false,
      showList:true,
      showForm:false,
      showFilter:false,
      showReport:false,
      reportUrl: null,
      issuedLines: {
          items: [],
          page: 1,
          limit: 5,
          total: 0,
      },
      issuedLinesObj: {
            asetid:'',
            asdesc: '',
            brand: '',
            lineno: 0,
                iteminfo: '',
                itemno: '',
                itemname: '',
                typeseries: '',
                serialNum: '',
                qtyIssued: 0,
                issueValue: 0,
                invunitom: '',
                qtyUndefined: 0,
                remark: '',
            },

      model: {
        tanggal:this.$store.state.user.tglaktif,
        uraian:'', 
        asuser:'', 
        aspublic:0,
        crewkey:'',
        aslocatkey:'', 
        aslocat:'', 
        targetkembali:0},
        tblFields:[
          {key: 'index', label: 'No.' ,thStyle: "width:40px"},
          {
            key: "asetid",
            thStyle: "width:100px",
            label: "FA Number",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          },
          {
            key: "asdesc",
            label: "FA Name/Description",
          },
          {
            key: "brand",
            label: "Brand",
          },
          {
            key: "asmodel",
            label: "Model/Type/Series",
          },
          {
            key: "asserial",
            label: "S/N",
          },
          {
            key: "nomorpo",
            label: "Nomor PO",
          },
          {
            key: "catgname",
            label: "Category/Group",
          },
          {
              key: "action",
              label: "Action",
              thStyle: "width:40px",
              thClass: "text-center",
          },
        ],
      warehouse:[],
    };
  },
  computed: {
    dimension(){
      return this.$store.state.dimension;
    },
    invalidFormdata() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
    invalidLinesObj() {
      this.$v.issuedLinesObj.$touch();
      return this.$v.issuedLinesObj.$invalid;
    },

  },
  created: async function(){
       crud.list({
        tablename:'itemstore',
        page: 1,
        limit: 10000,
        total: 0,
        sortBy: 'namaStore',
        sortDesc: false,
      })
      .then(gudangs => {
          gudangs.forEach(tp => {
            this.warehouse.push({...tp, 
              value: tp.idStore, 
              text: tp.namaStore
              });
          });   
      }).catch(err => {
          console.log('get Inventory Stores -> ', err);
      });

        if (this.$route.params.mutasikey)  {
            toastr.info('Loading Request Detail, please wait')
            try {
            const data = await fa_mutation.detail(this.$route.params) ;
            
            const row = data[0][0];
            // console.log('row ==>',row)
            // this.saveEnabled=(row.send2wf === 0);
            row.tanggal = row.tanggal ? moment(row.tanggal).format('YYYY-MM-DD') : '';
            row.tglkembali = row.tglkembali ? moment(row.tglkembali).format('YYYY-MM-DD') : '';
            for (var key in row) {
                this.model[key] = row[key];
            }
            
            this.issuedLines.items = data[1]
                this.issuedLines.total=this.issuedLines.items.length;
            toastr.clear;
            } catch (error) {
                console.log('error : ', error);
                toastr.error(JSON.stringify(error), "ERROR MESSAGE");                              
            }
        } 

        this.$watch('model.idStore', function(newval) {
            this.modal.aslocat='';
            const item = this.warehouse.find(p => p.value == newval);
            if (item) {
                this.modal.text;
            }

        })

  },  
  methods: {
    updateUser: function(){
        if (this.model.aspublic==0) {
          this.model.crewkey='';
          this.model.crewinfo='';
          this.model.asuser='G & A Department';
        } else {
          this.model.asuser='';
        }
    },
    save: async function (callback) {
        if (this.invalidFormdata) {
              const invalidobj = {};
                for (var key in this.$v.model) {
                if (this.$v.model[key].$anyError) {
                    if (this.$v.model[key].$anyError == true) invalidobj[key] = this.$v.model[key];
                }
                }
                console.log('validation model: ', this.model);
                console.log('validation field: ', invalidobj);
                toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
        } else {
            try {
                        this.model.mutasikey = this.model.mutasikey || '';
                        this.model.nomor = this.model.nomor || '';
                        const row = {};
                        for (var key in this.model) {
                            row[key] = this.model[key];
                        }
                        row.tanggal = moment(row.tanggal).format('YYYY-MM-DD');
                        row.tglkembali = (this.model.tglkembali) ? moment(row.tglkembali).format('YYYY-MM-DD') : '';
                        row.lines = this.issuedLines.items.reduce((newArr, item) => {
                            if (((item.asetkey || '') != '')) {
                                newArr.push(item);
                            }
                            return newArr;
                        }, []);
                        if (row.lines.length>0) {
                            await fa_mutation.save(row);
                            toastr.success("Complete successfully", "Save Inventory Issued");
                            this.close();
                        } else {
                            toastr.error('Please fill at least 1(one) Inventory Issued Detail', 'ERROR MESSAGE');
                            this.saveEnabled=true;
                        }
              this.close();    

            } catch (error) {
                // this.saveEnabled=true;
                // this.isLoading=false;
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }        
            }
        }
    },    
    onSelectLkuFixedAsset(lkuData) {
        console.log('Fixed Asset selected: ', lkuData.selected)
        this.lkuFixedAssetData=lkuData;
        this.lkuFixedAssetShow=false;
        const mmAda = this.issuedLines.items.find(c => c.asetkey == lkuData.selected.asetkey)
        if (mmAda) {
            toastr.warn(`${lkuData.selected.asetid} | ${lkuData.selected.asdesc} already Applied`);
        } else {
            if (this.model.aspublic=='-1') {
                if (lkuData.selected.itemno) {
                    const obj={};
                    for (var key in lkuData.selected) {
                        obj[key] = lkuData.selected[key];
                    }
                    this.issuedLines.items.push(obj);
                    this.issuedLines.total=this.issuedLines.items.length;
                } else {
                    this.addIssuedLines();
                    for (var key in lkuData.selected) {
                        this.issuedLinesObj[key] = lkuData.selected[key];
                    }
                }
            } else {
                const obj={};
                for (var key in lkuData.selected) {
                    obj[key] = lkuData.selected[key];
                }
                this.issuedLines.items.push(obj);
                this.issuedLines.total=this.issuedLines.items.length;
            }
        }
    },
    onSelectLkuItem(lkuData) {
        this.itemList=lkuData;
        this.lkuItemShow=false;

        this.issuedLinesObj.iteminfo = lkuData.selected.partnumber.trim() + ' | ' + lkuData.selected.itemname.trim();
        this.issuedLinesObj.partnumber = lkuData.selected.partnumber;
        this.issuedLinesObj.itemno = lkuData.selected.itemno;
        this.issuedLinesObj.itemname = lkuData.selected.itemname;
    },

    closeIssuedLines: function () {
        const opened = this.issuedLines.items.find((r) => r._showDetails == true);
        if (opened) opened._showDetails = false;
    },
    addIssuedLines: function () {
        this.closeIssuedLines();
        const obj = { _showDetails: true };
        this.issuedLines.selected = obj;
        // for (var key in this.issuedLinesObj) {
        //     this.issuedLinesObj[key] = "";
        // }
        this.issuedLinesObj.itemno='';
        this.issuedLinesObj.itemname='';
        this.issuedLines.items.push(obj);
        this.issuedLines.total = this.issuedLines.items.length;
    },
    delIssuedLines: function (index) {
        // if (index > -1) {
        // this.issuedLines.items.splice(index, 1);
        // }
        // this.issuedLines.total=this.issuedLines.items.length;
        const _selected = this.issuedLines.items[index];
        this.$bvModal.msgBoxConfirm(`${_selected.asetid} | ${_selected.asdesc}`, {
          title: 'Delete Confirm',
          buttonSize: 'sm',
          okVariant: 'danger',
          okTitle: 'YES',
          cancelTitle: 'NO',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true
        })
          .then(value => {
            if (value == true) {
                if (index > -1) {
                  // this.issuedLines.items.splice(index, 1);
                  const posisi = (this.issuedLines.page-1)*this.issuedLines.limit;
                  this.issuedLines.items.splice(posisi+index, 1);
                }
                this.issuedLines.total=this.issuedLines.items.length;
            }
          })
          .catch(err => {
            console.log(err);
            // An error occurred
          })

    },
    saveIssuedLines: async function (callback) {

            if (this.invalidLinesObj) {
                toastr.error("Mstr. Material Reference mandatory, can not be empty", "ERROR MESSAGE");
                const invalidobj = {};
                for (var key in this.$v.model) {
                if (this.$v.model[key].$anyError) {
                    if (this.$v.model[key].$anyError == true) invalidobj[key] = this.$v.model[key];
                }
                }
                console.log('validation model: ', this.model);
                console.log('validation field: ', invalidobj);
                toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
            } else {
                    for (var key in this.issuedLinesObj) {
                        this.issuedLines.selected[key] = this.issuedLinesObj[key];
                    }
                    this.issuedLines.selected._showDetails = false;
                    if (callback) callback();
            }
        },
    onSelectLkuCrew:  function (lkuData) {
        this.lkuCrewData=lkuData;
        this.lkuCrewShow=false;
        this.model.crewkey = lkuData.selected.crewkey;
        this.model.crewinfo = lkuData.selected.crewnik.trim() + ' | ' + lkuData.selected.crewname.trim();
        this.model.asuser = (lkuData.selected.departemen || '').trim();
        this.model.crewnik = lkuData.selected.crewnik;
        this.model.jabatan = lkuData.selected.jabatan;
        this.model.userdepartname = lkuData.selected.departemen.trim();
        this.model.userdepartid = lkuData.selected.departid;

    },
    onSelectLkuAssetlocat: async function (_selected) {
        this.model.lokasiinfo = _selected.kodelokasi.trim() + ' | ' + _selected.namalokasi.trim();
        // this.model.aslocat = _selected.namalokasi.trim();
        this.model.aslocatkey = _selected.aslocatkey;
        this.model.kodelokasi = _selected.kodelokasi;
        this.model.namalokasi = _selected.namalokasi;
        this.lkuAssetlocatShow=false;
    },
    onSelectLkuDept: async function (_selected) {
        this.model.userdepartname = _selected.departemen.trim();
        this.model.userdepartid = _selected.departid;
        this.model.asuser = _selected.departemen;
        this.lkuDeptShow=false;
    },

    close(){
        //   console.log('this.$store.state.prevRoute.name : ',this.$store.state.prevRoute.name);
        // if ((this.$store.state.prevRoute.name) && (this.$store.state.prevRoute.name !== 'fixedasset.mutationfrm')) {
        //     router.push({name:this.$store.state.prevRoute.name});
        // } else {
            router.push({name:'fixedasset.mutation'});
        // }
    },    
  }
};
</script>
